/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { Gallery, NAVIGATION_POSITION_TYPE } from "src/libs/useful/gallery/Gallery"
import { ALIGN } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { HTML as _HTML } from "../../contentType"
import DataDummy from "../../landing-edit/DataDummy"
import { IDataComponentsProps } from "../DataComponents"
import { setHorizontalAlignToCSSRule } from "../Section" 
import { DataContentAnimateContainer } from "./DataContentAnimateContainer"
import { DataContentPositionContainer } from "./DataContentPositionContainer"

/* Protopia Ecosystem component */
export interface ISectionCarouselProps extends IDataComponentsProps {
   
}
const SectionCarousel = (props: ISectionCarouselProps): JSX.Element => {
    const section               = props.section
    const currentDimensionEdit  = useLandingConsoleStore(( state: ILandingConsoleStore ) => state.currentDimensionEdit) 
    const composition           = useComposition( section ) 

    useEffect(() => {
        addCSSClass(
            `section-columns-container-${props.section.id}`,
            `.section-columns-container-${props.section.id} {
                ${setHorizontalAlignToCSSRule(props.section.vertical_align || ALIGN.MIDDLE )};
            }
            ${
                currentDimensionEdit <= WINDOW_WIDTH.TABLET &&
                `[class*='pe-next-button'] {
                    &[class*=middle-outer] {
                        @container (max-width: 995px) {
                            right: 0px!important;  
                            width:28px!important;
                            height:28px!important; 
                            font-size: 14px!important;
                        }
                    }
                }
                [class*='pe-prev-button'] {
                    &[class*=middle-outer] {
                        @container (max-width: 995px) {
                            left: 0px!important;  
                            width:28px!important;
                            height:28px!important; 
                            font-size: 14px!important;
                        }
                    }
                }`
            }`
        )
        return () => {
            removeCSSClass( `section-columns-container-${props.section.id}` )
        }
    }, [ currentDimensionEdit ])
 
    
    const cards = props.data.map((data, i) => { 
        if(data.isHidden) {
            return <DataDummy key={ data.id } data={data} section={props.section} />
        }
        const type = data.type
        const DataComponent = type && components()[ type ]
            ?
            components()[ type ].c
            :
            _HTML 
        return <DataContentAnimateContainer 
            {...props} 
            i={ i } 
            key={ data.id } 
            style={{ ...data.containerStyle, }} 
            // proportia={ !!composition.proportia ? composition.proportia[i] : undefined }
        >
            <DataContentPositionContainer {...props} i={i} >
                <DataComponent  
                    section={ section } 
                    data={ { ...data, type } } 
                /> 
            </DataContentPositionContainer>
        </DataContentAnimateContainer>
    })
    
    return <div 
        className={ `landing-data-components-container landing-edit-cont section-columns p-0 ${section.className || ""} section-columns-container-${props.section.id}` }  
        style={{...section.dstyle, gap: section.gap }} 
        data-proportia={composition.proportia.join(",")}
    >
        <Gallery 
            items={ cards } 
            itemWidth="100%"                
            // itemHeight={ section.itemStyle?.height || section.height } 
            itemStyle={{
                ...section.itemStyle, 
                "display": "flex",
                "flexDirection": "column",
                "margin": "auto 0",
                "justifyContent": "center" 
            }}
            pagination={ section.is_navigation }
            navigation
            autoHeight={ typeof section.carousel_auto_height !== "undefined" ? section.carousel_auto_height : true } 
            navigationType={ section.carousel_nav}
            navigationThemeType={ section.carousel_nav_theme }
            navigationSizeType={ section.carousel_nav_size }
            navigationDesignType={ section.carousel_nav_type }
            navigationPositionType={ section.carousel_nav_position || NAVIGATION_POSITION_TYPE.TOP_RIGHT} 
            galleryContainerClassName={`landing-section-gallery`}
            count={{
                [WINDOW_WIDTH.PANEL]    : composition.columns,
                [WINDOW_WIDTH.LARGE]    : composition.columns,
                [WINDOW_WIDTH.SCREEN]   : composition.columns,
                [WINDOW_WIDTH.TABLET]   : 1,
                [WINDOW_WIDTH.MOBILE]   : 1,
                [WINDOW_WIDTH.SMALL]    : 1,
            }}
            loop
            type="element"
            padding={ section.gap || 0 }
        /> 
    </div>
}
export default SectionCarousel